import config from '../config'
import { get, getWithRedirect } from './http-utils'

const serviceUrl = config.paymentMethodsPricingServiceUrl
const baseUrl = config.baseUrl
  ? `${config.baseUrl}${serviceUrl ? `/${serviceUrl}` : ''}`
  : serviceUrl
  ? `/api/${serviceUrl}`
  : '/api'

export const getFlexibleInvoice = ({
  storeId,
  paymentMethodId,
  channelType,
  amount,
}) =>
  getWithRedirect(
    `${baseUrl}/public/v2/store/${storeId}/payment_methods/${paymentMethodId}/channel_type/${channelType}/flexible_invoice?amount=${amount}`,
  )

export const getFlexibleInvoiceForBankproduct = ({
  storeId,
  channelType,
  bankproduct,
  amount,
  countryCode,
}) =>
  getWithRedirect(
    `${baseUrl}/public/v2/store/${storeId}/channel_type/${channelType}/bankproduct/${bankproduct}/flexible_invoice?amount=${amount}&countryCode=${countryCode}`,
  )

export const getPriceInfo = ({
  storeId,
  paymentMethodId,
  channelType,
  amount,
  repaymentPeriod,
}) => {
  const params = new URLSearchParams({ amount: String(amount) })
  if (repaymentPeriod) {
    params.append('repayment_months', repaymentPeriod)
  }

  return get(
    `${baseUrl}/public/v2/store/${storeId}/payment_methods/${paymentMethodId}/channel_type/${channelType}/price_info?${params.toString()}`,
  )
}
export const getPriceInfoForBankproduct = ({
  representativeId,
  storeId,
  bankproduct,
  channelType,
  countryCode,
  amount,
  repaymentPeriod,
  interestRate,
}) => {
  const params = new URLSearchParams({
    countryCode,
    amount,
  })

  if (repaymentPeriod) {
    params.append('repayment_months', repaymentPeriod)
  }
  if (interestRate) {
    params.append('interestRate', interestRate)
  }
  return get(
    `${baseUrl}/public/v2/representative/${representativeId}/store/${storeId}/bankproduct/${bankproduct}/price_info?${params.toString()}`,
  )
}
